import { Controller } from "@hotwired/stimulus";

// The AI generation ENDED while step 2 was open (the broadcast of `_ai_state`): done, failed,
// cancelled or uncertain. The form was frozen (`inert`) while it ran, so nothing typed can be
// lost — the page reloads on what arrived, and the form thaws (owner, 2026-10-20).
export default class extends Controller {
  connect() {
    window.Turbo.visit(window.location.href, { action: "replace" });
  }
}
